import * as Constants from '../Constant';

const initialState = {
    message: {},
    doctorList: {},
}

export default function doctorReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.POST_DOCTOR:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.GET_DOCTOR:
            return {
                ...state,
                doctorList: action.payload,
            }
        case Constants.UPDATE_DOCTOR:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.DELETE_DOCTOR:
            return {
                ...state,
                message: action.payload,
            }
        default:
            return state;
    }
}